<script>
import { replace } from 'svelte-spa-router';
import { PROVIDERS } from '../database.js';
import { FormValidator, InputValidator } from '../form.js';
import Inputmask from 'inputmask';
import { onMount } from 'svelte';
import * as user from '../user';
import * as utils from '../utils';

import Button from './button.svelte';
import AlternateHeader from './altheader.svelte';



const formValidator = FormValidator();

let firstName = '';
let lastName = '';
let phone = '';
let providerType = '';

let saving = false;
$:continueButtonState = saving ? 'loading' : '';

let phoneElement = null;
onMount(() =>
{
    window.scrollTo(0,0);

    let inputMask = Inputmask.default({"mask": "(999) 999-9999", oncomplete:function(key) {

    },
    onincomplete:function(key) {

    },
    }).mask(phoneElement);
});


function Go()
{
    if ($formValidator !== 1)
        return;

    // first make sure the user is still authenticated
    user.GetAuthOnly().then((u) =>
    {
        console.log('firstName', firstName);
        const _phone = phone.replace( /\D+/g, ''); // we only want numbers
        const details = {
            firstName,
            lastName,
            phone:_phone,
            providerType,
            signUpState:'needspayment', // waiting for payment
        }

        utils.log('Information', details);

        user.Update(u.uid, details).then(() =>
        {
            // yay... I think this means we can continue to the last step
            setTimeout(() =>
            {
                replace('/signup/payment');
            }, 400);

        })
        .catch((error) => {
            utils.error("Information Error (1)", error);

        });
    })
    .catch((error) =>
    {
        utils.error('Information Error (2)', error);

    });

}

</script>

<AlternateHeader/>

<div class="container main medium" style="margin-top: 0;">
  <section class="line-after">
    <header class="major center">
        <div class="image"><img src="images/whiteLogo.png" alt="" /></div>
    </header>
  </section>
  <section>
    <header>
        <h5>Step 3 of 4</h5>
        <h4 style="color: white; margin-bottom: 3em;">Enter your information</h4>
    </header>
    <form on:submit|preventDefault="{Go}" novalidate>
      <div class="row gtr-uniform">
          <div class="col-12 col-12-xsmall">
            <label for="firstname">FIRST NAME</label>
            <input use:InputValidator={formValidator} type="text" name="firstName" bind:value={firstName} placeholder="Jane" />
            <div class="errorMsg">This field is required</div>
          </div>
          <div class="col-12 col-12-xsmall">
            <label for="lastname">LAST NAME</label>
            <input use:InputValidator={formValidator} type="text" name="lastName" bind:value={lastName} placeholder="Smith" />
            <div class="errorMsg">This field is required</div>
          </div>
          <div class="col-12 col-12-xsmall">
            <label for="phone">PHONE NUMBER</label>
            <input use:InputValidator={formValidator} type="tel" name="phone" bind:this={phoneElement} bind:value={phone} placeholder="(999) 999-9999" />
            <div class="errorMsg">Enter a valid phone number</div>
          </div>
          <div class="col-12 col-12-xsmall">
            <label for="provider">PROVIDER TYPE</label>
                  <select class="form" use:InputValidator={formValidator} name="provider" bind:value={providerType}>
                      <option value="">- Select a provider type -</option>
                  {#each Object.entries(PROVIDERS) as [value, display]}
                      <option value={value}>{display}</option>
                  {/each}
                  </select>
                  <div class="errorMsg">Please select a provider type</div>
          </div>
          <div class="col-12 col-12-xsmall">
            <ul class="actions special">
              <li>
                  <Button state={continueButtonState} class="button fit" text="CONTINUE"/>
              </li>

            </ul>
          </div>
        </div>

    </form>
  </section>
</div>

<style>
@media screen and (max-width: 480px) {
  header.center {
    text-align: center;
}}

h5 {
  color: #c5c5c5 !important;
  font-weight:normal;
}

.col-12.col-12-xsmall {
  padding-top: 1em;
}

li, .button.fit {
  width: 100%;
}

input.error
{
    border-color: red;
}

.errorMsg
{
    padding-left:1px;
    color: red;
    text-align: left;
    margin-top: .5em;
    display: none;
}

header.major { margin: 1em 0 0 0; }
.container > section.line-after:after {
  content: '';
  display: inline-block;
  width: 90%;
  height: 0.25rem;
  margin: 1em 5%;
  border-radius: 4px;
  background-color: #4a98e2;
}

@media screen and (max-width: 480px) {
  .container > section.line-after:after {
    width: 100%;
    height: 0.25rem;
    margin: 1em 0;
  }
}

@media screen and (max-width: 736px) {
  .image > img {
    max-width: 90%;
    margin: 0 auto;
  }
}

form a
{
    color: rgb(103, 189, 255);
    border-bottom: 0;
}
.errorMsg
{
    color: red;
    text-align: left;
}

input.error
{
    border-color: red;
    border-width: 2px;
}

.container.medium.main {
  background-color: #1a242f !important;
  padding-top: 0;
  font-size: 13pt;
}

.container.medium.main input {
    background-color: rgb(0 0 0 / .3);
}

.container.medium.main h4, .container.medium.main h6, input, label {
  color: #fff !important;
}

label {font-weight: 400;}

.container.medium.main {
  width: 500px;
  max-width: 500px;
}

@media screen and (max-width: 736px) {
  .container.medium.main {
    width: 425px;
  }
}

@media screen and (max-width: 480px) {
  .container.medium.main {
    width: 275px;
  }
}

@media screen and (max-width: 320px) {
  .container.medium.main {
    width: 250px;
  }
}


ul.actions.special >li { width: 100%; margin: 1em 0 0 0;}


#cardHolder
{
    max-height: 70px;
    overflow:hidden;
}
#card-element
{
    background-color:rgba(144,144,145,0.075);
	border-radius: 6px;
	border: solid 1px #e2eaec;
    padding: .75em 1em .75em 1em;
}

.container.medium
{
    margin-top:20px;
}

.discountMsg
{
    padding-left:10px;
}

.discountMsg.error
{
    color: red;
}

.hide
{
    display:none;
}

</style>
